.td {
  display: block;
  min-height: 40px;
  font-size: 0.875rem;
  line-height: 1rem;
  font-weight: var(--ixf-font-weight-main-medium);
  background: var(--ixf-table-background-color);
  color: var(--ixf-text-tone-md);

  a,
  button {
    z-index: 2;
  }

  &.isPinnedLeft,
  &.isPinnedRight {
    position: sticky;
    z-index: 3;
  }

  &.isPinnedLeft {
    left: 0;
    border-right: var(--ixf-table-border);
    box-shadow: var(--ixf-table-pinned-column-left-box-shadow);
  }

  &.isPinnedRight {
    right: 0;
    border-left: var(--ixf-table-border);
    box-shadow: var(--ixf-table-pinned-column-right-box-shadow);
  }

  &.isSubRowCell {
    width: 100%;
    display: flex;
    padding: var(--ixf-table-cell-spacing-vertical) 0;

    .content {
      width: 100%;
      justify-content: stretch;
      flex: 1 1 auto;

      > * {
        flex: 1 1 auto;
      }

      &.align {
        &-left {
          > * {
            text-align: left;
          }
        }

        &-center {
          > * {
            text-align: center;
          }
        }

        &-right {
          > * {
            text-align: right;
          }
        }
      }
    }
  }

  .content {
    padding: var(--ixf-table-cell-spacing-vertical)
      var(--ixf-table-cell-spacing-horizontal);
  }

  .content,
  .cellText {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;

    &.align {
      &-left {
        justify-content: flex-start;
      }

      &-center {
        justify-content: center;
      }

      &-right {
        justify-content: flex-end;
      }
    }
  }
}

.rowActionContainer {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 1;

  .rowAction {
    display: flex;
    position: relative;
    height: 100%;
    width: 100%;

    &:focus {
      outline: none;
    }
  }
}
